<template>
  <div
    class="bc-status"
    :class="alignmentClass"
  >
    <em
      v-if="detail.bc_sync_running"
      class="icon-reload text-success"
      :title="$t('tenders.loading')"
    ></em>

    <em
      v-else-if="detail.bc_synced"
      class="icon-check"
      :title="$t('tenders.bc_synced_status.synced')"
    ></em>

    <div
      v-else-if="loading"
      class="lds-ring"
      :title="$t('tenders.loading')"
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>

    <button
      v-else
      class="btn btn-sm btn-circle btn-outline-danger"
      :title="$t('tenders.synchronize')"
      @click="sync"
    >
      <em class="icon-exclamation"></em>
    </button>
  </div>
</template>

<script>
import api from '@/api'
import message from '@/message'

export default {
  name: "BCDetailStatus",

  props: {
    detail: {
      type: Object,
      required: true
    },
    justifyContent: {
      type: String,
      default: "center"
    }
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    alignmentClass() {
      return `justify-content-${this.justifyContent}`
    }
  },

  methods: {
    sync() {
      this.loading = true

      api.post(`/details/${this.detail.id}/bc-synchronize/`)
        .then(json => {
          this.detail.bc_synced = json.data.bc_synced
          this.detail.bc_sync_running = json.data.bc_sync_running
        })
        .finally(() => {
          if (this.detail.bc_synced) {
            message.success('Business centrali sünkroniseerimine õnnestus', false)
          } else if (this.detail.bc_sync_running) {
            message.success('Business centrali sünkroniseerimine on juba alanud', false)
          } else {
            message.error('Business centrali sünkroniseerimine ebaõnnestus')
          }

          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BCDetailStatus.vue